import { StateSchema } from 'app/config/storeConfig/types';
import { UserDetailsInfo } from 'widgets/UserDetailsForm';

export const getUserDetailsInfo = (state: StateSchema): UserDetailsInfo => state.bookingPage.useDetailsForm;
